import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function impactUserReducer(
  state = initialState.impactUserStats,
  action
) {
  switch (action.type) {
    case types.USER_IMPACT_SUCCESS:
      return action.impactUserStats;
    case types.USER_IMPACT_FAILED:
      return action.error;
    default:
      return state;
  }
}
